import React from "react";
import { Star, MessageSquareText, Link2Off, CalendarClock, Sparkles, UserRound } from "lucide-react";
import { sourceMeta, Stars } from "./shared";

function Card({ icon: Icon, label, value, sub, tone = "blue", testId }) {
  const tones = { blue: "text-blue-400 bg-blue-600/15", amber: "text-amber-400 bg-amber-500/15", emerald: "text-emerald-400 bg-emerald-500/15", rose: "text-rose-400 bg-rose-500/15", violet: "text-violet-300 bg-violet-500/15" };
  return (
    <div className="flex items-center gap-3 bg-slate-800/50 border border-slate-700 rounded-xl px-4 py-3 min-w-[170px]" data-testid={testId}>
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${tones[tone]}`}><Icon className="w-4 h-4" /></div>
      <div>
        <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
        <div className="text-lg font-bold text-white leading-tight">{value}</div>
        {sub && <div className="text-[11px] text-slate-400">{sub}</div>}
      </div>
    </div>
  );
}

export default function StatsStrip({ stats, onUnmatchedClick, onSuggestedClick, onGarsonSuggestedClick, onSourceClick, activeSource }) {
  if (!stats) {
    return (
      <div className="flex flex-wrap gap-3 mb-5" data-testid="review-stats-loading">
        {[0, 1, 2].map(i => <div key={i} className="h-[62px] min-w-[170px] rounded-xl bg-slate-800/40 border border-slate-700/60 animate-pulse" />)}
        <div className="h-[62px] flex-1 min-w-[260px] rounded-xl bg-slate-800/40 border border-slate-700/60 animate-pulse" />
      </div>
    );
  }
  const t = stats.totals || {};
  return (
    <div className="flex flex-wrap gap-3 mb-5" data-testid="review-stats">
      <Card icon={MessageSquareText} label="Toplam Yorum" value={t.total ?? 0} sub={`son 30 gün: ${t.last_30 ?? 0}`} testId="stat-total" />
      <Card icon={Star} label="Ortalama" value={t.avg_rating != null ? `${t.avg_rating} / 5` : "-"} sub={<Stars value={Math.round(t.avg_rating || 0)} />} tone="amber" testId="stat-avg" />
      <button onClick={onUnmatchedClick} className="text-left" data-testid="stat-unmatched-btn">
        <Card icon={Link2Off} label="Eşleşmedi" value={t.unmatched ?? 0} sub={`son 30 gün: ${t.unmatched_30 ?? 0} · tıkla, listele`} tone={t.unmatched_30 ? "rose" : "emerald"} />
      </button>
      {!!t.suggested && (
        <button onClick={onSuggestedClick} className="text-left" data-testid="stat-suggested-btn">
          <Card icon={Sparkles} label="Öneri Bekliyor" value={t.suggested} sub="isim+tarih eşleşmesi · onaylayın" tone="violet" />
        </button>
      )}
      {!!t.garson_suggested && (
        <button onClick={onGarsonSuggestedClick} className="text-left" data-testid="stat-garson-suggested-btn">
          <Card icon={UserRound} label="Garson Önerisi" value={t.garson_suggested} sub="belirsiz isim · onaylayın" tone="violet" />
        </button>
      )}
      <div className="flex items-center gap-1.5 bg-slate-800/50 border border-slate-700 rounded-xl px-3 py-2 flex-1 min-w-[260px] flex-wrap" data-testid="stat-by-source">
        <CalendarClock className="w-4 h-4 text-slate-500 mr-1" title="Kaynağa tıkla, o kaynağı filtrele" />
        {(stats.by_source || []).length === 0 && <span className="text-xs text-slate-500">Henüz kaynak yok</span>}
        {(stats.by_source || []).map(s => {
          const m = sourceMeta(s.source);
          const active = activeSource === s.source;
          return (
            <button key={s.source} onClick={() => onSourceClick && onSourceClick(active ? "" : s.source)} data-testid={`stat-source-${s.source}`}
              className={`flex items-center gap-1.5 text-xs rounded-lg px-2 py-1 transition-colors border ${active ? "border-current bg-white/5" : "border-transparent hover:bg-white/5"}`}
              style={active ? { color: m.color } : undefined} title={`${m.label}: ${s.count} yorum, ort. ${s.avg_rating} — tıkla, filtrele`}>
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: m.color }} />
              <span className={active ? "font-semibold" : "text-slate-300"}>{m.short}</span>
              <span className={active ? "font-bold" : "text-white font-semibold"}>{s.count}</span>
              {s.avg_rating != null && <span className="text-amber-400">★{s.avg_rating}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
